import { AuthorizationParams, useAuth0 } from "@auth0/auth0-react";
import { APIProvider } from "@certn/api";
import { Loader } from "@certn/cascadia-react";
import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  domain: string;
  authorizationParams: AuthorizationParams;
}

export const APIProviderWrapper = (props: Props) => {
  const { getAccessTokenSilently } = useAuth0();

  return (
    <APIProvider
      domain={props.domain}
      getAccessToken={() =>
        getAccessTokenSilently({
          authorizationParams: props.authorizationParams,
        })
      }
      fallback={<Loader overlay />}
    >
      {props.children}
    </APIProvider>
  );
};
